import { Empty } from 'antd';
import invariant from 'tiny-invariant';

import { useAppContext } from 'business/contextProviders/useAppContext';
import { useGetDataQuery } from 'business/steering/hooks/use-get-steering-data-query';
import { SteeringTableFilterData } from 'business/steering/pages/table-page';
import { SteeringGraph } from 'business/steering/pages/table-page/components/chart/steering-graph';
import { FilterDataSetter } from 'technical/filter-data';
import Loader from 'ui/loader';

export const SteeringGraphContainer = ({
  setFilterData,
}: {
  setFilterData?: FilterDataSetter<SteeringTableFilterData>;
}) => {
  const { currentConstructionSiteId: constructionSiteId } = useAppContext();
  invariant(constructionSiteId, 'No construction site id');

  const { data, loading } = useGetDataQuery({
    constructionSiteId,
    setFilterData,
  });

  if (loading) {
    return <Loader />;
  }

  if (!data || !data.parameter_ring.length) {
    return <Empty />;
  }

  return <SteeringGraph data={data?.parameter_ring} />;
};
